














import { Component, Prop, Vue } from "vue-property-decorator";
import { germanZahl } from '../../helper/utils';

@Component({
    name: "GuvTableItem" 
})
export default class GuvTableItem extends Vue {
    @Prop() item!: any
    @Prop() type!: any

    get values(){
        return this.item.value || [];
    }

    get extConfig(){
        return this.item.extconfig || {};
    }

    getGermanZahl(val:any){
       return germanZahl(val);
    }
}
